import { setPath } from "Dotpulse.Basic/Resources/Private/Components/Variables";
import "Dotpulse.Basic/Resources/Private/Components/Dropdown/jQuery.js";
import jump from "jump.js";

import TrackingInfo from "./TrackingInfo";
import "./Lightbox";
import "./Swiper";
import "./Filter/Filter";
import "./Filter/Toggle";
import "./ClickAndCollect";
import "./OrderStatus";
import "./Glide";
import "./SimpleParallax";

window.path = setPath({ theme: assetPackageKey });
window.trackingInfo = TrackingInfo();
window.trackingInfo().init();

//== IE
let ua = window.navigator.userAgent;
let msie = ua.indexOf("MSIE ");
if (msie !== -1 || /Trident.*rv[ :]*11\./.test(navigator.userAgent)) {
  document.documentElement.classList.add("is-ie");
}

//== Mobile menu
$(document.documentElement).on("click", ".mobile-menu-link a", event => {
  event.preventDefault();
  $("body").toggleClass("menu-is-active");
});

//== Main menu
const closeMainMenu = () => {
  $("body").removeClass("main-menu-is-active");
  $(".hamburger").removeClass("is-active");
};

const toggleMainMenu = event => {
  event.preventDefault();
  event.stopPropagation();
  $(event.target)
    .closest(".hamburger")
    .toggleClass("is-active");
  $("body").toggleClass("main-menu-is-active");
};

$(document.documentElement)
  .on("click", ".hamburger", toggleMainMenu)
  .on("click", (event) => {
    if ($(event.target).closest(".main-menu").length <= 0) {
      closeMainMenu();
    }
  });

//== Scoll
$(document.documentElement).on("click", ".scroll-to-link", event => {
  event.preventDefault();
  let scrollToId = event.target.href.split("#")[1];
  if (scrollToId) {
    jump("#" + scrollToId, {
      offset: $("body").hasClass("page-site-style-quaicafe") ? -80 : -140
    });
    $("body").removeClass("menu-is-active");
    closeMainMenu();
  }
});

//== Neos Backend: open link in new window
$(document.documentElement).on("click", ".btn-neos-open-new-window", event => {
  event.preventDefault();
  let url = $(event.target).data("href");
  if ($(event.target).has(".append-cache-buster")) {
    url = url + "?t=" + Date.now();
  }
  window.open(url, "_blank");
});

//== Load Scripts
if ($("form.styled-form").length > 0) {
  $.getScript(window.path.scripts + "Form.js");
}

if ($(".background-replace-controls").length > 0) {
  $.getScript(window.path.scripts + "BackgroundReplace.js");
}

if ($(".week-slider").length > 0) {
  $.getScript(window.path.scripts + "WeekSlider.js");
}
